export const pagesBaseUrl = process.env.REACT_APP_PAGES_BASE_URL;
export const apxBaseUrl = process.env.REACT_APP_APX_BASE_URL;
export const stripeKey = process.env.REACT_APP_STRIPE_KEY || '';
export const imagesUrl = `${process.env.REACT_APP_PAGES_BASE_URL}/assets/images`;

export const essentialGroupId = process.env.REACT_APP_ESSENTIAL_GROUP_ID;
export const premiumGroupId = process.env.REACT_APP_PREMIUM_GROUP_ID;

export const estimatedTimeBeforeRenewal = process.env.REACT_APP_ESTIMATED_TIME_BEFORE_RENEWAL;

export const backToAppLink = process.env.REACT_APP_BACK_TO_APP_LINK;

export const sentryErrorTrackingDsn = process.env.REACT_APP_SENTRY_ERROR_TRACKING_DSN;

export const blackListedCountries = process.env.REACT_APP_B2C_BLACK_LISTED_COUNTRIES?.split(',');

export const onlyEssentialCountries = process.env.REACT_APP_ONLY_ESSENTIAL_COUNTRIES?.split(',');

export const firebaseAppId = process.env.REACT_APP_FIREBASE_APP_ID;

export const firebaseMeasurementId = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;

export const releaseVersion = process.env.REACT_APP_VERSION;
